import { FolderOverviewState } from '../models'

export const folderOverviewInitialState: FolderOverviewState = {
  folder: null,
  folderScopes: [],
  retainedHoursStats: null,
  isLoading: false,
  trafficStatus: null,
}
